import * as React from "react";
import { useId } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProfile = (props) => {
	const __svgrId = useId();
	return /* @__PURE__ */ _jsx("svg", {
		fill: "none",
		viewBox: "0 0 32 32",
		xmlns: "http://www.w3.org/2000/svg",
		...props,
		children: /* @__PURE__ */ _jsxs("g", {
			transform: "translate(0.4706 0) scale(0.9412)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M10.9524 18.3017 C10.9524 18.3017 12.7524 20.7017 15.7525 20.7017 C18.7525 20.7017 20.5525 18.3017 20.5525 18.3017 M19.3524 12.3017 L19.3644 12.3017 M12.1525 12.3017 L12.1645 12.3017 M27.7525 15.9017 C27.7524 22.5291 22.3799 27.9017 15.7525 27.9017 C9.1251 27.9017 3.7525 22.5292 3.7525 15.9017 C3.7525 9.2743 9.125 3.9017 15.7524 3.9017 C22.3799 3.9017 27.7525 9.2743 27.7525 15.9017 Z M19.9525 12.3017 C19.9525 12.6331 19.6839 12.9017 19.3524 12.9017 C19.0211 12.9017 18.7525 12.6331 18.7524 12.3018 C18.7525 11.9703 19.0211 11.7017 19.3525 11.7017 C19.6838 11.7017 19.9524 11.9703 19.9525 12.3017 Z M12.7525 12.3017 C12.7524 12.6331 12.4838 12.9017 12.1525 12.9017 C11.8211 12.9017 11.5525 12.633 11.5525 12.3017 C11.5525 11.9703 11.821 11.7017 12.1525 11.7017 C12.4838 11.7017 12.7524 11.9703 12.7525 12.3017 Z",
					stroke: "white",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 5.5
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M15.7525 27.9017 C22.3799 27.9017 27.7524 22.5291 27.7525 15.9017 C27.7525 9.2743 22.3799 3.9017 15.7524 3.9017 C9.125 3.9017 3.7525 9.2743 3.7525 15.9017 C3.7525 22.5292 9.1251 27.9017 15.7525 27.9017 Z",
					style: { fill: "var(--sticker-pastel,#FFC98E)" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M10.9524 18.3017 C10.9524 18.3017 12.7524 20.7017 15.7525 20.7017 C18.7525 20.7017 20.5525 18.3017 20.5525 18.3017",
					style: { fill: "var(--sticker-pastel,#FFC98E)" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M19.9525 12.3017 C19.9525 12.6331 19.6839 12.9017 19.3524 12.9017 C19.0211 12.9017 18.7525 12.6331 18.7524 12.3018 C18.7525 11.9703 19.0211 11.7017 19.3525 11.7017 C19.6838 11.7017 19.9524 11.9703 19.9525 12.3017 Z",
					style: { fill: "var(--sticker-pastel,#FFC98E)" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M12.7525 12.3017 C12.7524 12.6331 12.4838 12.9017 12.1525 12.9017 C11.8211 12.9017 11.5525 12.633 11.5525 12.3017 C11.5525 11.9703 11.821 11.7017 12.1525 11.7017 C12.4838 11.7017 12.7524 11.9703 12.7525 12.3017 Z",
					style: { fill: "var(--sticker-pastel,#FFC98E)" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M10.9524 18.3017 C10.9524 18.3017 12.7524 20.7017 15.7525 20.7017 C18.7525 20.7017 20.5525 18.3017 20.5525 18.3017 M19.3524 12.3017 L19.3644 12.3017 M12.1525 12.3017 L12.1645 12.3017 M27.7525 15.9017 C27.7524 22.5291 22.3799 27.9017 15.7525 27.9017 C9.1251 27.9017 3.7525 22.5292 3.7525 15.9017 C3.7525 9.2743 9.125 3.9017 15.7524 3.9017 C22.3799 3.9017 27.7525 9.2743 27.7525 15.9017 Z M19.9525 12.3017 C19.9525 12.6331 19.6839 12.9017 19.3524 12.9017 C19.0211 12.9017 18.7525 12.6331 18.7524 12.3018 C18.7525 11.9703 19.0211 11.7017 19.3525 11.7017 C19.6838 11.7017 19.9524 11.9703 19.9525 12.3017 Z M12.7525 12.3017 C12.7524 12.6331 12.4838 12.9017 12.1525 12.9017 C11.8211 12.9017 11.5525 12.633 11.5525 12.3017 C11.5525 11.9703 11.821 11.7017 12.1525 11.7017 C12.4838 11.7017 12.7524 11.9703 12.7525 12.3017 Z",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 1.5,
					style: { stroke: "var(--sticker-dark,#9A6528)" }
				})
			]
		})
	});
};
export default SvgProfile;
